module.exports = __webpack_public_path__ + "img/heading_uk.d740d0a6.svg";